<template>
    <section class="py-5" id="admin_reseau">
		<div class="row">
			<div class="col-lg-12 text-center">
				<h2 class="section-heading text-uppercase">Administrateur réseau</h2>
				<h3 class="section-subheading text-muted">Métier d'administration et de gestion de réseau.</h3>
			</div>
		</div>
		
		<div class="container">
		  <div class="row">
			<div class="col-md-3 col-sm-6">
			  <a href="#">
				<img class="img-fluid d-block mx-auto" src="img/cablage_reseau.jpg" alt="cablage réseau">
			  </a>
			</div>
			<div class="col-md-3 col-sm-6">
			  <a href="#">
				<img class="img-fluid d-block mx-auto" src="img/routage.jpg" alt="routage">
			  </a>
			</div>
			<div class="col-md-3 col-sm-6">
			  <a href="#">
				<img class="img-fluid d-block mx-auto" src="img/securite.jpg" alt="sécurité">
			  </a>
			</div>
			<div class="col-md-3 col-sm-6">
			  <a href="#">
				<img class="img-fluid d-block mx-auto" src="img/droits.jpg" alt="droits">
			  </a>
			</div>
		  </div>
		  
		  <div class="row">
			<div class="col-lg-12 text-center adminres"> 
				<p class="text-muted">
				Un administrateur réseau est une personne chargée de la gestion du réseau, de gérer les comptes et les machines d'un réseau informatique 
				d'une organisation, comme une entreprise, cela peut concerner notamment des concentrateurs, des commutateurs, des routeurs, des modems, un pare-feu, le proxy, 
				la connectivité Internet, les réseaux privés virutels (VPN). Ils sont souvent assisté d'un ingénieur qui conçoit une architecture réseau. L'administration 
				de réseau est une discipline de l'informatique qui peut éventuellement s'étendre à la téléphonie. L'administrateur réseau est parfois également administrateur système,
				il gère alors également les postes de travail, PC ou Macintosh, les imprimantes et les serveurs de l'entreprise.
				</p>
			</div>
			
			<div class="col-lg-12 text-center adminres"> 
				<h2 class="section-heading text-uppercase">Tâches de l'administrateur</h2>
				
				<p class="text-muted paragraphs-tech">
					<ul class="list-group">
						<li class="list-group-item">gestion du câblage réseau : connexion physique entre plusieurs machines</li>
						<li class="list-group-item">gestion du routage : connexion logique entre l'intérieur et l'extérieur du réseau ou entre plusieurs sous-réseaux</li>
						<li class="list-group-item">gestion de la sécurité : protection antivirale, pare-feu, préventions des intrustions, etc</li>
						<li class="list-group-item">gestion des droits d'accès des utilisateurs : accès au réseau, etc</li>
					</ul>
				</p>
			</div>
			
			<div class="col-lg-12 text-center adminres"> 
				<h2 class="section-heading text-uppercase">Administration de réseaux</h2>
				
				<p class="text-muted paragraphs-tech">
				L'administrateur désignement plus spécifiquement les opérations de contrôle du réseau avec la gestion des configurations et de sécurité.
				De façon générale, une administration de réseau a pour objectif d'englober un ensemble de techniques de gestion mises en oeuvre pour : 
				
				<ul class="list-group">
					<li class="list-group-item">offrir aux utilisateurs une certaine qualité de service</li>
					<li class="list-group-item">permettre l'évolution du système en incluant de nouvelles fonctionnalités</li>
					<li class="list-group-item">rendre opérationnel un système</li>
				</ul>
					
				L'administration d'un réseau peut se decomposer en 3 types d'administration.
				</p>
			</div>
			
			<div class="col-lg-12 text-center adminres"> 
				<h2 class="section-heading text-uppercase">Utilisateurs</h2>
				
				<p class="text-muted paragraphs-tech">
				L'administration des utilisateurs fournit l'ensemble des mécanismes nécessaires pour une personne afin d'utiliser le réseau, à savoir :  
				
				<ul class="list-group">
					<li class="list-group-item">
					Accessibilité et Connectivité aux applications : l'utilisateur doit pouvoir se connecter aux différentes 
					applications fournit par le réseau et doit disposer d'un ensemble d'outils lui assurant une certaine 
					transparence au niveau des méthodes d'accès et connexions aux applications.
					</li>
					<li class="list-group-item">
					L’accès aux serveurs de noms, afin de permettre la localisation des ressources et d'assurer à l'utilisateur l'existence et l'utilisation de ces ressources.
					</li>
					<li class="list-group-item">
					La Confidentialité et la Sécurité. Le système doit fournir l'ensemble des mécanismes qui permettent de garantir la 
					confidentialité des informations de l'utilisateur, de sécuriser son environnement et de prévenir toute perte ou 
					altération des échanges effectués par l'utilisateur.
					</li>
					<li class="list-group-item">
					La Qualité de service fournit à l'utilisateur. Il s'agit principalement de la disponibilité et des performances du système et sa capacité à assurer le service 
					attendu.
					</li>
				</ul>				
				</p>
			</div>
		  </div>			
		</div>
		<hr>
	 </section>
</template>

<script>
export default {
    
}
</script>

<style lang="css">

</style>


